exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-ma-index-js": () => import("./../../../src/pages/ma/index.js" /* webpackChunkName: "component---src-pages-ma-index-js" */)
}

